var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTetherCoinRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M54.25 28C54.25 13.503 42.498 1.75 28 1.75S1.75 13.503 1.75 28 13.503 54.25 28 54.25 54.25 42.498 54.25 28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3fa",
    d: "M30.487 28.851v-.003c-.14.01-.86.052-2.464.052a52 52 0 0 1-2.5-.052v.003c-4.932-.22-8.61-1.083-8.61-2.121 0-1.035 3.681-1.902 8.61-2.121v3.381c.321.023 1.247.079 2.522.079 1.533 0 2.3-.066 2.442-.079v-3.378c4.922.223 8.59 1.087 8.59 2.121s-3.671 1.899-8.59 2.121zm0-4.59v-3.024h6.867v-4.612H18.659v4.612h6.867v3.025c-5.581.258-9.776 1.371-9.776 2.707s4.198 2.448 9.776 2.71v9.696h4.964v-9.696c5.572-.258 9.76-1.371 9.76-2.707 0-1.332-4.188-2.448-9.76-2.707"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 56,
    x2: 0,
    y1: 0,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04412e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#30bb8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b5a42"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTetherCoinRounded);
export default __webpack_public_path__ + "static/media/tetherCoinRounded.3f3d01c8b98f7333f06d4a23d55f4504.svg";
export { ForwardRef as ReactComponent };